export default () => [
  {
    name: 'Leasing',
    value: 'Leasing',
  },
  {
    name: 'Events',
    value: 'Events',
  },
  {
    name: 'Promotions',
    value: 'Promotions',
  },
  {
    name: 'Sponsorships',
    value: 'Sponsorships',
  },
  {
    name: 'Careers',
    value: 'Careers',
  },
  {
    name: 'Others',
    value: 'Others',
  },
]
